import React from 'react';
import './CurrentActivity.css';

// Shows the active event so the user understands why heating is on and when it will stop. Impromptu
// events are labelled "Temporal" (they are time-limited and revert to standby on expiry); an
// open-ended activity (end far in the future) shows no end time. The slot keeps a fixed height when
// empty so switching to standby does not shift the controls below.
const CurrentActivity = ({ activity }) => {
  const label = activity?.isImpromptu ? 'Temporal' : activity?.title;
  const end = activity ? new Date(activity.endTime) : null;
  const hasEnd = end && end.getFullYear() < 9000;
  const endStr = hasEnd
    ? end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : null;

  return (
    <div className="current-activity-slot text-center my-2">
      {activity && (
        <span className="badge bg-secondary">
          {label}{endStr ? ` · termina ${endStr}` : ''}
        </span>
      )}
    </div>
  );
};

export default CurrentActivity;
